import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotVideos from "./components/HotVideos";
import LatestArticles from "./components/LatestArticles";
import FAQSection from "./components/FAQSection";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "17.c 起草在线观看免费版",
  url: "https://17c-drafting.example.com",
  description: "17.c 起草在线观看免费版为您提供最新免费在线观看渠道、高清播放入口及观看指南。无需下载、即点即播。",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://17c-drafting.example.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "17.c 起草在线观看",
  url: "https://17c-drafting.example.com",
  description: "专注于影视内容在线观看的中文平台",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+86-400-123-4567",
    contactType: "customer service",
    availableLanguage: "Chinese",
  },
};

export default function Home() {
  return (
    <main>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <HeroSection />
      <CategoryNav />
      <HotVideos />
      <LatestArticles />
      <FAQSection />
    </main>
  );
}